'use client';
import PoolMobile from '@/public/poolMobile.svg';
import { useMemo } from 'react';
import useSWR from 'swr';
import { API_ENDPOINTS } from '../../api/contants';
import { AprData, AssetsData, InitialData, TvlData } from '../../api/types';
import { closedChainIds, testnetChainIds } from '../../blockchain/constanst';
import { Hero } from '../../sections/Hero/Hero';
import { HowItWorks } from '../../sections/HowItWorks/HowItWorks';
import { Metrics } from '../../sections/Metrics/Metrics';
import { Vaults } from '../../sections/Vaults/Vaults';
import styles from './DynamicSections.module.scss';

interface IDynamicSectionsProps {
  initialData: InitialData;
}

export const DynamicSections = ({ initialData }: IDynamicSectionsProps) => {
  const { assets: assetsData, tvls: initialTvlData, aprs: initialAprData } = initialData || {};

  const { data: tvls } = useSWR<TvlData[]>(API_ENDPOINTS.TVL, {
    fallbackData: initialTvlData
  });

  const { data: aprs } = useSWR<AprData[]>(API_ENDPOINTS.APR, {
    fallbackData: initialAprData
  });

  const filteredAssets: AssetsData[] | undefined = useMemo(() => {
    return assetsData?.filter(
      (asset) =>
        !testnetChainIds.includes(asset?.chainId ?? 0) &&
        !closedChainIds.includes(asset?.chainId ?? 0) &&
        !asset?.isHidden &&
        asset?.type === 'potion'
    );
  }, [assetsData]);

  const assetKeySet = useMemo(() => {
    if (!filteredAssets) return new Set<string>();
    return new Set(filteredAssets.map((asset) => `${asset.chainId}-${asset.address?.toLowerCase()}`));
  }, [filteredAssets]);

  const filteredAprs: AprData[] | undefined = useMemo(() => {
    return aprs?.filter((apr) => assetKeySet.has(`${apr.chainId}-${apr.address?.toLowerCase()}`));
  }, [aprs, assetKeySet]);

  const filteredTvls: TvlData[] | undefined = useMemo(() => {
    return tvls?.filter((tvl) => assetKeySet.has(`${tvl.chainId}-${tvl.address?.toLowerCase()}`));
  }, [tvls, assetKeySet]);

  const formatedInitialData: InitialData = useMemo(() => {
    return {
      assets: filteredAssets,
      tvls: filteredTvls,
      aprs: filteredAprs
    };
  }, [filteredTvls, filteredAssets, filteredAprs]);

  return (
    <div>
      <Hero initialData={formatedInitialData} />
      <div className={`${styles.container}`}>
        <PoolMobile className={styles.poolMobile} />
        <Vaults initialData={formatedInitialData} />
        <Metrics initialData={formatedInitialData} />
        <HowItWorks />
      </div>
    </div>
  );
};
